import { AsyncPipe, KeyValuePipe, NgForOf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { selectPopoverConfigLang } from '@core/consts/select-popover-config';
import { StoreKeysMainEnum, StoreKeysSubEnum } from '@core/enums/store-keys.enum';
import { CalcCssVarsService } from '@core/services/calc-css-vars.service';
import { StorageService } from '@core/services/storage.service';
import { TranslateCommonService } from '@core/services/translate.service';
import { originalOrder } from '@core/utils/original-order';
import { IonicModule } from '@ionic/angular';
import { Components } from '@ionic/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { LanguagesEnum } from 'src/app/core/enums/langs.enum';
import IonSelect = Components.IonSelect;

@Component({
    selector: 'ncodp-lang-control',
    templateUrl: 'lang-control.component.html',
    styleUrls: ['lang-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonicModule, TranslateModule, ReactiveFormsModule, KeyValuePipe, NgForOf, AsyncPipe],
})
export class LangControlComponent implements OnInit, OnDestroy {
    public originalOrder = originalOrder;
    public readonly languagesEnum = LanguagesEnum;
    @ViewChild('langSelect', { read: ElementRef }) public langSelect!: { nativeElement: IonSelect };
    public selectPopoverConfig = selectPopoverConfigLang;
    public lang = new FormControl('');
    private translateChangesSubscription: Subscription | null = null;
    private valueChangesSubscription: Subscription | null = null;
    private calcCssVarsService = inject(CalcCssVarsService);
    public isMobileView$ = this.calcCssVarsService.isMobileView$;

    constructor(
        private storageService: StorageService,
        private translate: TranslateCommonService,
        private cdr: ChangeDetectorRef,
    ) {}

    public openSelect(): void {
        if (this.langSelect) {
            this.langSelect?.nativeElement?.open().then();
        }
    }
    public ngOnInit(): void {
        this.translateChangesSubscription = this.translate.translateChanges$.subscribe((lang) => {
            this.lang.setValue(lang, { emitEvent: false });
            this.selectPopoverConfig = {
                ...selectPopoverConfigLang,
            };
            this.cdr.detectChanges();
        });
        this.valueChangesSubscription = this.lang.valueChanges
            .pipe(
                switchMap((lang) =>
                    this.storageService.setSubItem(StoreKeysSubEnum.APP_LANG, lang, StoreKeysMainEnum.SETTINGS).pipe(map(() => lang)),
                ),
                switchMap((lang) => {
                    this.translate.setTranslateLang(lang as string);
                    this.cdr.detectChanges();

                    return this.storageService.setSubItem(StoreKeysSubEnum.APP_LANG_SET_USER, true, StoreKeysMainEnum.SETTINGS);
                }),
            )
            .subscribe();
    }

    public ngOnDestroy(): void {
        this.translateChangesSubscription?.unsubscribe();
        this.valueChangesSubscription?.unsubscribe();
    }
}
